import styled from '@emotion/styled';
import Skeleton from '@mui/material/Skeleton';
import { SidePanelRoot, SidePanelWrap } from '@trinity/chat-components/components/Chat.SidePanel';
import { ChatTrackSkeleton } from '@trinity/chat-components/components/Chat.SidePanel/ChatTrackSkeleton';

// Matches the real `ChatSidePanel`'s own initial width (see getInitialPanelWidth in
// SidePanel.tsx) so swapping it in once ready causes no further width change. Reuses its
// shared Root/Wrap shell (border/shadow per `themeVersion`) and mirrors header/message/composer rows
// so the panel doesn't visibly re-layout once the real content swaps in.
// Only for the very first wait: once the real panel has been shown, the host keeps it mounted and
// lets it show `ChatTrackSkeleton` itself, so its header doesn't flash.
export const SidePanelPendingPlaceholder = ({
  width,
  themeVersion,
}: {
  width: number;
  themeVersion: 'v1' | 'v2';
}) => (
  <SidePanelRoot themeVersion={themeVersion} role="status" aria-label="Loading chat">
    <PlaceholderWrap customWidth={width} themeVersion={themeVersion}>
      <PlaceholderHeaderRow style={{ padding: '15px 0' }}>
        <Skeleton variant="rounded" width={30} height={30} />
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <Skeleton variant="rounded" width="200px" height={30} />
        </div>
        <Skeleton variant="rounded" width={30} height={30} />
        <Skeleton variant="rounded" width={30} height={30} />
      </PlaceholderHeaderRow>
      <div style={{ paddingBottom: '15px' }}>
        <Skeleton variant="rounded" width="100%" height={32} />
      </div>
      <ChatTrackSkeleton />
    </PlaceholderWrap>
  </SidePanelRoot>
);

// Reuses the real panel's shell, plus the padding/gap the real header/content rows
// otherwise provide for themselves.
const PlaceholderWrap = styled(SidePanelWrap)({
  gap: 16,
  padding: 16,
});

const PlaceholderHeaderRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});
